import React from 'react';
import Immutable from 'immutable';

import {
  Container,
  Button, Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Paragraph } from '@uncinc/react-drupal-core';

import { WysiwygField, Share } from '../../../../components';
import './style.scss';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';

import MemberWall from '../../../../components/MemberWall';
import NewsletterBlock from '../../../../components/NewsletterBlock';
import useLoggedInStatus from '../../../../hooks/useLoggedInstatus';

const TaxonomyCampaign = ({ entity }) => {
  const { isLoggedIn } = useLoggedInStatus();
  const superTitle = entity.getIn(['field_supertitle', 0, 'value']);
  const subTitle = entity.getIn(['field_sub_title', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const isMemberOnlyContent = entity.getIn(['field_member_only_content', 0, 'value'], false);


  const showMemberWall = !isLoggedIn && isMemberOnlyContent;

  return (
    <div className="TaxonomyCampaign">
      <Container>
        <div className="TaxonomyCampaign__hero">
          {entity.getIn(['field_media_image', 0]) && (
            <Image
              lazyload={false}
              className="TaxonomyCampaign__hero__image"
              includeWebP
              src={{
                [SCREEN_MOBILE]: entity.getIn(['field_media_image', 0, 'styles', 'hero_mobile']),
                [SCREEN_TABLET]: entity.getIn(['field_media_image', 0, 'styles', 'hero_tablet']),
                [SCREEN_NORMAL]: entity.getIn(['field_media_image', 0, 'styles', 'hero_desktop']),
              }}
              alt={entity.getIn(['field_media_image', 0, 'alt'], '')}
            />
          )}

        </div>
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div className="TaxonomyCampaign__intro">

              <div className="TaxonomyCampaign__intro__wrapper">
                <div className="TaxonomyCampaign__intro__wrapper__supertitle">{superTitle}</div>
                <h1>{entity.getIn(['name', 0, 'value'], '')}</h1>
                <div className="TaxonomyCampaign__intro__wrapper__subtitle">{subTitle}</div>
              </div>

              {entity.getIn(['description', 0, 'processed']) ? (
                <div className="TaxonomyCampaign__body__wrapper">
                  <WysiwygField
                    property="schema:text"
                    className="TaxonomyCampaign__body"
                    html={entity.getIn(['description', 0, 'processed'], '')}
                  />
                  {linkUri && (
                    <Button href={linkUri}>
                      {linkTitle} <i className="icon icon-arrow-right" />
                    </Button>
                  )}
                </div>
              ) : null}

            </div>
          </div>
        </div>
      </Container>

      <div className="NodeContentWrapper">
        {entity.get('field_paragrafen') ? (
          <div className="TaxonomyCampaign__paragraphs">
            {entity.get('field_paragrafen', Immutable.List()).map((paragraph, index) => {
              if (showMemberWall && index > 0) return;
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}

        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <Share />
            </div>
          </div>
        </Container>
      </div>

      {/* Member wall. */}
      {showMemberWall && (
        <MemberWall />
      )}

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </div>
  );
};

export default TaxonomyCampaign;
